import Settings from "./Settings"

export interface RecordWithPhoto {
  imagen?: string | null
  imagenUrl?: string | null
}

/**
 * Resuelve de dónde sale la foto de una persona y devuelve el src listo para un <img>.
 *
 * Hay dos orígenes conviviendo y no son intercambiables:
 *
 *  - `imagenUrl` es una RUTA de archivo — sale de una foto ya migrada al filesystem,
 *    o de CEDULADO_IMG.ruta_foto en el padrón. Se sirve como archivo estático.
 *  - `imagen` es el blob de PadronFotos.Fotos en Base64, para las cédulas que
 *    todavía no se han migrado.
 *
 * La razón de que esto exista en un solo lugar: la versión anterior armaba siempre
 * `"data:image/png;base64," + imagen`, sin distinguir. Cuando lo que llegaba era una
 * ruta, el navegador recibía `data:image/png;base64,e:\jce\048\...` y fallaba — eran
 * 930,639 cédulas mostrando el placeholder de error.
 *
 * Devuelve null cuando no hay foto, para que quien llama decida qué mostrar.
 */
export function resolvePhotoSrc(record: RecordWithPhoto): string | null {
  if (record.imagenUrl) {
    const relativa = record.imagenUrl.replace(/^\/+/, "")
    return `${Settings.BasePath}${relativa}`
  }

  if (record.imagen) {
    return `data:image/png;base64,${record.imagen}`
  }

  return null
}

export const PHOTO_FALLBACK = "https://placehold.co/600x400"
